export default __webpack_public_path__ + "assets/images/enhancedWebswitcherIMG3.svg";